import { useAppContext } from "../context/siteMapContext";

interface IWaterMark {
  transparent: boolean
  isLarge: boolean;
}

const WaterMark: React.FC<IWaterMark> = ({ transparent, isLarge = false }) => {
  const { highContrastOn } = useAppContext();

  return <>{!highContrastOn && (
    <picture className='flex'>
      <source srcSet='/body/18_white.png' type='image/webp' />
      {/* eslint-disable-next-line @next/next/no-img-element */}
      {!isLarge ? (<img
        className='w-[46px] 2xl:w-[22vw] h-auto mx-auto absolute bottom-0 z-0 right-page-side-padding'
        style={{
          opacity: transparent ? '0.2' : 1,
        }}
        src='/body/18_white.png'
        tabIndex={-1}
        role="presentation"
        alt="védjegy"
        height={200}
        width={200}
      />) : (
        <img
          className='w-[44vw] md:w-[22vw] h-auto mx-auto absolute bottom-20 md:bottom-10 z-0 right-page-side-padding'
          style={{
            opacity: transparent ? '0.2' : 1,
          }}
          src='/body/18_white.png'
          tabIndex={-1}
          role="presentation"
          alt="védjegy"
        height={200}
        width={200}
        />
      )}
    </picture>
  )}
  </>
}

export default WaterMark
